import React from 'react';
import './FirstClassification.less';
import autobind from 'autobind-decorator';
import store from '../../store';

export interface FirstClassificationPropType {
    prefixCls?: string;
    classificationList?: any[]; // 一级分类数据
    onTabClick?: (id?: any, index?: any) => void; // 切换点击事件
}

export interface FirstClassificationState {
    tabIndex: number;
}

/**
 * 分类 - 一级分类
 * @class FirstClassification
 * @extends {React.Component<FirstClassificationPropType, FirstClassificationState>}
 */
class FirstClassification extends React.Component<FirstClassificationPropType, FirstClassificationState> {
    static defaultProps = {
        prefixCls: 'firstClassification',
    };

    state = {
        tabIndex: 0, // 当前切换索引
    };

    // 点击事件
    @autobind
    onTabClick(id, tabIndex) {
        const {onTabClick} = this.props;
        if (onTabClick) {
            onTabClick(id);
        }
        this.setState({tabIndex});
        store.classification.setFirstState(tabIndex);
        console.log(store.classification.firstSate);
    }

    render() {
        const {prefixCls, classificationList = []} = this.props;
        const firstSate = store.classification.firstSate;
        const tabIndex = firstSate && classificationList.length > firstSate ? firstSate : 0;
        return (
            <div className={`${prefixCls}firstBox-inner`}>
                {
                    classificationList && classificationList.length > 0 && classificationList.map((item, index) => {
                        return (
                            <div
                                className={`${prefixCls}-item clearfix ` + (index === tabIndex ? `${prefixCls}-item-active` : ``)}
                                key={index} onClick={() => {
                                this.onTabClick(item['uuidId'], index);
                            }}>
                                <p className={index === tabIndex ? `${prefixCls}-p-active` : ``}>{item.name.length > 4 ? item.name.substr(0, 4) : item.name}</p>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default FirstClassification;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/firstClassification/FirstClassification.tsx